var _ellipse, _ellipse2, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 69,
    viewBox: "0 0 97 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.5,
    cy: 26,
    rx: 7.5,
    ry: 8,
    fill: "#E1E6F3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 58.5,
    rx: 26,
    ry: 10.5,
    fill: "#E1E6F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5833 44.2431C85.9456 44.2431 96.7778 55.0753 96.7778 68.4375H36.2917C36.2917 55.0753 47.1239 44.2431 60.4861 44.2431H72.5833ZM36.2917 44.2431C38.111 44.2431 39.8835 44.4439 41.588 44.8245C34.6718 50.367 30.2431 58.885 30.2431 68.4375H0C0 55.0753 10.8322 44.2431 24.1944 44.2431H36.2917ZM72.5793 50.2917H60.4821C52.5813 50.2917 45.8599 55.3411 43.3688 62.3889H89.6926C87.2016 55.3411 80.4801 50.2917 72.5793 50.2917ZM29.0451 50.2917H24.1904C16.2896 50.2917 9.56819 55.3411 7.07715 62.3889H24.6941C25.4168 58.0905 26.9013 54.0014 29.0451 50.2917ZM30.2431 14C36.9242 14 42.3403 19.4161 42.3403 26.0972C42.3403 32.7783 36.9242 38.1944 30.2431 38.1944C23.5619 38.1944 18.1458 32.7783 18.1458 26.0972C18.1458 19.4161 23.5619 14 30.2431 14ZM66.5347 14C73.2158 14 78.6319 19.4161 78.6319 26.0972C78.6319 32.7783 73.2158 38.1944 66.5347 38.1944C59.8536 38.1944 54.4375 32.7783 54.4375 26.0972C54.4375 19.4161 59.8536 14 66.5347 14ZM30.2431 20.0486C26.9025 20.0486 24.1944 22.7567 24.1944 26.0972C24.1944 29.4378 26.9025 32.1458 30.2431 32.1458C33.5836 32.1458 36.2917 29.4378 36.2917 26.0972C36.2917 22.7567 33.5836 20.0486 30.2431 20.0486ZM66.5347 20.0486C63.1942 20.0486 60.4861 22.7567 60.4861 26.0972C60.4861 29.4378 63.1942 32.1458 66.5347 32.1458C69.8753 32.1458 72.5833 29.4378 72.5833 26.0972C72.5833 22.7567 69.8753 20.0486 66.5347 20.0486Z",
    fill: "#1B0076"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 5,
    r: 5,
    fill: "#E71E3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users-2.363b04fb.svg";
export { ForwardRef as ReactComponent };